<h5><i class="icon-link"></i> Link {{{getLocaleTextHTML title}}}</h5>
<span class="actions">
	<button class="btn-link up"><i class="icon-arrow-up"></i></button>
	<button class="btn-link down"><i class="icon-arrow-down"></i></button>
	<button class="btn-link remove"><i class="icon-remove"></i></button>
	<button class="btn-link left"><i class="icon-pencil"></i></button>
</span>
<div class="child-link-selector" style="display: none;"></div>
